(function () {
  'use strict';
  angular.module('vcfinance.unicat')
    .component('unicatnew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="unicatnew-component" data-hook="unicatnew-component">
        <h3>Neue/s unicat anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addUnicat()" ng-hide="vm.newunicat">Neue/s unicat anlegen</div>
        <div ng-show="vm.newunicat">
          <unicatform unicat="vm.newunicat" parentsave="vm.saveNewUnicat(unicat)" oncancel="vm.cancel()"></unicatform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> unicat erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen unicat wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> unicat konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Unicat', 'Rlog',
        function ($log, Unicat, Rlog) {
          let vm = this;
          vm.addUnicat = addUnicat;
          vm.saveNewUnicat = saveNewUnicat;
          vm.cancel = cancel;
          
          function addUnicat() {
            vm.newunicat = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewUnicat(unicat) {
            $log.debug('debug: create new unicat: ', unicat);
            delete vm.newunicat;
            Unicat.$create(unicat).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new unicat failed: ', err);
              Rlog.error('vcutils.unicat', 'unicatnew', 'Creation of new unicat failed: ', {error: err, unicat: vm.newunicat});
            });
          }
          
          function cancel() {
            delete vm.newunicat;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());